import { render, staticRenderFns } from "./AddRelationship.vue?vue&type=template&id=c37e1e2a&scoped=true"
import script from "./AddRelationship.vue?vue&type=script&lang=js"
export * from "./AddRelationship.vue?vue&type=script&lang=js"
import style0 from "./AddRelationship.vue?vue&type=style&index=0&id=c37e1e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37e1e2a",
  null
  
)

export default component.exports